import { Calculation } from "final-form-calculate";

import contextStore, { ContextStore } from "stores/contextStore";

// To be used in conjunction with final-form-calulator's `createDecorator` function.
// Returns a function with will reset a field to null, unless the form is being mounted
// in which case the initial value is preserved.
//
// It's also possible to force a value from the global context.

export function createFieldResetter<FormValues>(
  accessor: keyof FormValues,
  resetValue: any,
  forcedContextStoreAccessor?: keyof ContextStore
) {
  return {
    [accessor]: (newValue: any, allValues?: any, prevValues?: any) => {
      // If we're using a value from the global context then we try
      // to fetch that value.  Ideally we'd use the values pulled in from contextStore.useState,
      // however that causes this calculator to be recreated each time those values change,
      // and react-final-form doesn't like the calulator to change.  To avoid this we fetch
      // the raw value dynmically.

      const forcedValue = forcedContextStoreAccessor
        ? (contextStore.getRawState() as ContextStore)[
            forcedContextStoreAccessor
          ]
        : undefined;

      // Note that prevValues is empty when the form is first displayed,
      // and in that case we need to keep the initial values that are passed in.
      return (
        forcedValue ??
        ((prevValues as FormValues)[accessor]
          ? resetValue ?? null
          : (allValues as FormValues)[accessor])
      );
    },
  };
}

// To be used in conjunction with final-form-calulator's `createDecorator` function.
// may be overridden by the global context.

export function globalContextUpdaters(updates: object) {
  return [
    {
      field: "applicationId",
      updates,
    },
  ] as Calculation[];
}

export const parseInteger = (value: string) =>
  isNaN(parseInt(value, 10)) ? "" : parseInt(value, 10);

export const parseDecimal = (value: string) =>
  isNaN(parseFloat(value)) ? "" : parseFloat(value);

export const isEmptyOrSpaces = (str: string) =>
  str === undefined || str === null || str.trim().match(/^ *$/) !== null;
